var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m5.5 22c0-4.8 4.3-8 9.7-8s9.7 3.2 9.7 8z",
  fill: "#e8b45a"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 17.7,
  rx: 0.9,
  ry: 0.55,
  fill: "#fff3da"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.2,
  cy: 16.6,
  rx: 0.9,
  ry: 0.55,
  fill: "#fff3da"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.3,
  cy: 17.9,
  rx: 0.9,
  ry: 0.55,
  fill: "#fff3da"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 5.2,
  y: 22,
  width: 20,
  height: 1.7,
  fill: "#57b368"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 23.7,
  r: 1.3,
  fill: "#57b368"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.8,
  cy: 23.7,
  r: 1.3,
  fill: "#57b368"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.6,
  cy: 23.7,
  r: 1.3,
  fill: "#57b368"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.3,
  cy: 23.7,
  r: 1.3,
  fill: "#57b368"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 24.8,
  width: 18.5,
  height: 1.6,
  fill: "#f2c14e"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 5.8,
  y: 26.4,
  width: 19,
  height: 2.6,
  rx: 1.3,
  fill: "#8a5a33"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 5.5,
  y: 29,
  width: 19.7,
  height: 4.2,
  rx: 2,
  fill: "#d99a3f"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 5,
  width: 1.7,
  height: 8.5,
  rx: 0.85,
  fill: "#e0704f",
  transform: "rotate(14 34.3 13)"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 12.3,
  width: 8,
  height: 1.4,
  rx: 0.7,
  fill: "#3d8fa3"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 27.8,
  y: 13.6,
  width: 12.4,
  height: 2,
  rx: 1,
  fill: "#3d8fa3"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m28.5 15.6h11l-1.3 15.9c-0.1 1-0.9 1.7-1.9 1.7h-4.6c-1 0-1.8-0.7-1.9-1.7z",
  fill: "#4fb3c6"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 29.3,
  y: 20.5,
  width: 9.4,
  height: 2.6,
  fill: "#dff2f7"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.8,
  cy: 28.8,
  r: 1.9,
  fill: "#57b368"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 27.7,
  r: 2,
  fill: "#3f8f4f"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.3,
  cy: 28.5,
  r: 1.9,
  fill: "#57b368"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 27.8,
  r: 2,
  fill: "#3f8f4f"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 31.4,
  cy: 28.8,
  r: 1.8,
  fill: "#57b368"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.3,
  cy: 27,
  r: 0.95,
  fill: "#c8503f"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 26.7,
  r: 0.95,
  fill: "#c8503f"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 24.1,
  y: 26,
  width: 2.2,
  height: 0.95,
  rx: 0.45,
  fill: "#e8923a",
  transform: "rotate(18 25.2 26.5)"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 29.6,
  y: 27.2,
  width: 2.2,
  height: 0.95,
  rx: 0.45,
  fill: "#e8923a",
  transform: "rotate(-14 30.7 27.7)"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 27,
  r: 0.7,
  fill: "#8e6bb5"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.6,
  cy: 28.7,
  r: 0.55,
  fill: "#f2c14e"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.4,
  cy: 28.9,
  r: 0.55,
  fill: "#f2c14e"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.7,
  cy: 29,
  r: 0.55,
  fill: "#f2c14e"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m18.5 29.5h15c0 4-3.3 6.5-7.5 6.5s-7.5-2.5-7.5-6.5z",
  fill: "#dfe6ec"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 18.5,
  y: 29.5,
  width: 15,
  height: 1.3,
  rx: 0.65,
  fill: "#c3ccd2"
});

function SvgFoodAndBeveragesNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodAndBeveragesNew);
export default __webpack_public_path__ + "static/media/food-and-beverages-new.a5f905286900c5fec30638dc99235171.svg";
export { ForwardRef as ReactComponent };